"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultDbGuidLocationGroups2 = exports.defaultDbGuidLocationGroups1 = exports.defaultDbGuidLocationGroupBus2 = exports.defaultDbGuidLocationGroupBus = exports.defaultDbGuidLocationGroupWalk = void 0;
var DbGuideLocationGroup_1 = require("@/pages/dbguide/states/DbGuideLocationGroup");
exports.defaultDbGuidLocationGroupWalk = {
    type: DbGuideLocationGroup_1.DbGuideLocationType.WALKING,
    locations: [
        {
            name: 'DB Plaza',
            center: {
                lat: 22.2952428,
                lng: 114.0144792,
            },
            distanceValue: 0,
            distanceUnit: 'km',
        },
        {
            name: 'North Plaza',
            center: {
                lat: 22.3071237,
                lng: 114.0158462,
            },
            distanceValue: 0,
            distanceUnit: 'km',
        },
    ],
};
exports.defaultDbGuidLocationGroupBus = {
    type: DbGuideLocationGroup_1.DbGuideLocationType.BUS,
    locations: [
        {
            name: 'DB Plaza',
            routeName: '9A',
            durationValue: 10,
            durationUnit: 'min',
            link: '#',
        },
        {
            name: 'North Plaza',
            routeName: null,
            durationValue: null,
            durationUnit: null,
            link: null,
        },
    ],
};
exports.defaultDbGuidLocationGroupBus2 = {
    type: DbGuideLocationGroup_1.DbGuideLocationType.BUS,
    locations: [
        {
            name: 'North Plaza',
            routeName: null,
            durationValue: null,
            durationUnit: null,
            link: null,
        },
    ],
};
exports.defaultDbGuidLocationGroups1 = [
    exports.defaultDbGuidLocationGroupWalk,
    exports.defaultDbGuidLocationGroupBus,
];
exports.defaultDbGuidLocationGroups2 = [
    exports.defaultDbGuidLocationGroupBus2,
];
